// sort array with text property by reference, alphabetically, ascending.
export const alphaSort = objects => {
  if (objects.length > 0) {
    return objects.sort(function(a, b) {
      return a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1;
    });
  }
};



// WEBPACK FOOTER //
// ./src/common/Helpers/SortHelper.js